import { useInView } from "@/lib/anim";

const C = { x: 460, y: 290 };

const RING = [
  { label: "Banks", x: 128, y: 128 },
  { label: "Payment Networks", x: 356, y: 72 },
  { label: "Acquirers", x: 592, y: 96 },
  { label: "Cards", x: 762, y: 200 },
  { label: "Wallets", x: 776, y: 388 },
  { label: "Payment Gateways", x: 612, y: 494 },
  { label: "FX Providers", x: 312, y: 500 },
  { label: "KYC / eKYC", x: 138, y: 420 },
  { label: "Fraud & Risk", x: 92, y: 258 },
];

const ENDPOINTS = [
  { label: "Businesses", x: 196, y: 592 },
  { label: "Fintechs", x: 384, y: 592 },
  { label: "Merchants", x: 572, y: 592 },
  { label: "Consumers", x: 748, y: 592 },
];

const RING_NODE_W = 152;
const ENDPOINT_NODE_W = 118;

function nodeWidth() {
  return RING_NODE_W;
}

export default function EcosystemDiagram() {
  const [ref, inView] = useInView({ threshold: 0.25 });
  return (
    <div ref={ref} className={`eco-viz ${inView ? "is-visible" : ""}`}>
      <svg
        data-testid="ecosystem-diagram"
        viewBox="0 0 920 640"
        className="h-auto w-full"
        role="img"
        aria-label="Financial ecosystem diagram showing iJeeva payment infrastructure connecting banks, payment networks, acquirers, cards, wallets, gateways, FX, KYC and fraud systems to businesses, fintechs, merchants and consumers"
      >
        <defs>
          <filter id="ecoShadow" x="-40%" y="-40%" width="180%" height="180%">
            <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#0F172A" floodOpacity="0.07" />
          </filter>
          <filter id="ecoHubShadow" x="-40%" y="-40%" width="180%" height="180%">
            <feDropShadow dx="0" dy="12" stdDeviation="26" floodColor="#1D305B" floodOpacity="0.2" />
          </filter>
        </defs>

        {/* links to ring */}
        {RING.map((n, i) => (
          <line
            key={`r-${n.label}`}
            x1={C.x}
            y1={C.y}
            x2={n.x}
            y2={n.y}
            stroke={i % 2 === 0 ? "#2563EB" : "#0EA5A4"}
            strokeWidth="1.3"
            strokeDasharray="3 9"
            opacity="0.55"
            className="viz-link"
            style={{ transitionDelay: `${i * 90}ms`, animationDelay: `${i * 0.3}s` }}
          />
        ))}
        {/* links to endpoints */}
        {ENDPOINTS.map((n, i) => (
          <line
            key={`e-${n.label}`}
            x1={C.x}
            y1={C.y + 44}
            x2={n.x}
            y2={n.y - 22}
            stroke="#94A3B8"
            strokeWidth="1.2"
            strokeDasharray="3 9"
            opacity="0.6"
            className="viz-link"
            style={{ transitionDelay: `${500 + i * 110}ms` }}
          />
        ))}

        {/* ring nodes */}
        {RING.map((n, i) => {
          const w = nodeWidth(n.label);
          return (
            <g key={n.label} className="viz-node" style={{ transitionDelay: `${120 + i * 80}ms` }} filter="url(#ecoShadow)">
              <rect x={n.x - w / 2} y={n.y - 19} width={w} height="38" rx="10" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.2" />
              <circle cx={n.x - w / 2 + 16} cy={n.y} r="3" fill={i % 2 === 0 ? "#2563EB" : "#0EA5A4"} />
              <text x={n.x - w / 2 + 26} y={n.y + 4} fontSize="12" fontWeight="500" fill="#1D305B" fontFamily="Inter, sans-serif">
                {n.label}
              </text>
            </g>
          );
        })}

        {/* endpoint nodes */}
        {ENDPOINTS.map((n, i) => {
          const w = ENDPOINT_NODE_W;
          return (
            <g key={n.label} className="viz-node" style={{ transitionDelay: `${650 + i * 90}ms` }} filter="url(#ecoShadow)">
              <rect x={n.x - w / 2} y={n.y - 19} width={w} height="38" rx="10" fill="#F1F5F9" stroke="#E2E8F0" strokeWidth="1.2" />
              <text x={n.x} y={n.y + 4} textAnchor="middle" fontSize="12" fontWeight="600" fill="#334155" fontFamily="Inter, sans-serif">
                {n.label}
              </text>
            </g>
          );
        })}

        {/* hub */}
        <g className="viz-node" style={{ transitionDelay: "0ms" }} filter="url(#ecoHubShadow)">
          <rect x={C.x - 118} y={C.y - 44} width="236" height="88" rx="14" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.2" />
          <image href="/logo.png" x={C.x - 80} y={C.y - 34} width="160" height="52" preserveAspectRatio="xMidYMid meet" />
          <text x={C.x} y={C.y + 30} textAnchor="middle" fontSize="10" fontWeight="600" letterSpacing="1.6" fill="#0EA5A4" fontFamily="Inter, sans-serif">
            PAYMENT INFRASTRUCTURE
          </text>
        </g>
      </svg>
    </div>
  );
}
